import { Repository } from "./adapters/repository";

import * as retrievePlanzoneLogs from "./useCases/retrievePlanzoneLogs";

enum UseCases {
  retrievePlanzoneLogs = "retrievePlanzoneLogs",
}

interface Core {
  [UseCases.retrievePlanzoneLogs]: retrievePlanzoneLogs.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrievePlanzoneLogs]: retrievePlanzoneLogs.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
